import { addDisplayName, flowMax } from 'ad-hok'
import { FC } from 'react'
import { TagInput } from 'shared/src/api/types'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { FormProps } from './resource'
import { NumberField, TextAreaNew, TextField } from './TextField'
import { Toggle } from './Toggle'

export interface FormValues
  extends Omit<
    Partial<TagInput>,
    'position' | 'includeFeaturesInFeed' | 'usedForCreatorFund'
  > {
  position?: string
  includeFeaturesInFeed: boolean
  usedForCreatorFund: boolean
}

export const TagForm: FC<FormProps<FormValues>> = flowMax(
  addDisplayName('TagForm'),
  addTranslationHelpers,
  ({ values, onChange, errors, t }) => (
    <div>
      <TextField
        id="name"
        label={t('admin.resources.tags.fields.name')}
        value={values.name ?? ''}
        onChange={(name) => onChange({ ...values, name })}
        error={errors.name}
        focusOnMount
      />
      <NumberField
        id="position"
        label={t('admin.resources.tags.fields.position')}
        value={values.position}
        onChange={(position) => onChange({ ...values, position })}
        error={errors.position}
      />
      <TextAreaNew
        id="notificationMessage"
        label={t('admin.resources.tags.fields.notificationMessage')}
        value={values.notificationMessage ?? ''}
        onChange={(notificationMessage) =>
          onChange({ ...values, notificationMessage })
        }
        error={errors.notificationMessage}
        focusOnMount
      />
      <Toggle
        id="includeFeaturesInFeed"
        label={t('admin.resources.tags.fields.includeFeaturesInFeed')}
        value={values.includeFeaturesInFeed}
        onChange={(includeFeaturesInFeed) =>
          onChange({ ...values, includeFeaturesInFeed })
        }
      />
      <Toggle
        id="usedForCreatorFund"
        label={t('admin.resources.tags.fields.usedForCreatorFund')}
        value={values.usedForCreatorFund}
        onChange={(usedForCreatorFund) =>
          onChange({ ...values, usedForCreatorFund })
        }
      />
    </div>
  )
)
